<template>
	<loader v-if="loading" />
	<page v-else>
		<div class="xpage-breadcrumbs">
			<router-link
				to="/dashboard"
				class="icon-home"
			></router-link>
			<span>></span>
			<router-link to="/administration">Administration</router-link>
		</div>

		<div class="xpage-inner">
			<h2>Administration</h2>
		</div>
	</page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Page from '../components/layout/Page.vue';
import Loader from '@/components/Loader.vue';
import { $api } from '@/services/api';

export default defineComponent({
	components: {
		Page,
		Loader,
	},
	data: () => ({
		loading: true as boolean,
	}),
	async mounted() {
		this.loading = false;
	},
});
</script>
